import { lazy } from "react";

export const ScheduleAsync = lazy(() => import("./Schedule"));
